document.addEventListener("DOMContentLoaded", function (event) {
  calculadoraBarfDiv_create();
  calculadoraBarf_event_submit();
});

function calculadoraBarfDiv_create() {
  const calculadoraBarfDiv = document.querySelector('.calculadora-barf');
  if (!calculadoraBarfDiv) {
    return false;
  }
  const formularioHTML = `
        <h2>Calculadora de cantidad BARF para perros y gatos</h2>
        <form id="form-calculadora-barf">
            <label for="tipo">Tipo de mascota:</label>
            <select id="tipo" name="tipo">
                <option value="perro">Perro</option>
                <option value="gato">Gato</option>
            </select>
            <label for="edad">Edad (meses):</label>
            <input type="number" id="edad" name="edad" min="0" required>
            <label for="peso">Peso (kg):</label>
            <input type="number" id="peso" name="peso" step="0.1" min="0" required>
            <label for="actividad">Nivel de actividad:</label>
            <select id="actividad" name="actividad">
                <option value="alta">Alta</option>
                <option value="normal">Normal</option>
                <option value="sedentario">Sedentario</option>
                <option value="deportista">Deportista o lebrel</option>
                <option value="mini">Mini</option>
                <option value="castrado">Castrado</option>
            </select>
            <button type="submit" class="btn btn-primary">Calcular</button>
        </form>
        <div id="resultado-calculadora-barf"></div>
<p>En Naturalwil te ofrecemos&nbsp;<a href="https://naturalwil.com/es/28-dieta-barf-para-mascotas">dieta barf para mascotas</a>&nbsp;con menús formulados por veterinarios y nutricionistas.</p>
    `;

  calculadoraBarfDiv.innerHTML = formularioHTML;
}

function calculadoraBarf_event_submit() {
  var calculadoraBarfForm = document.getElementById('form-calculadora-barf');
  if (!calculadoraBarfForm) {
    return false;
  }

  calculadoraBarfForm.addEventListener('submit', function (e) {
    e.preventDefault();
    const tipo = document.getElementById('tipo').value;
    const edad = parseInt(document.getElementById('edad').value, 10);
    const peso = parseFloat(document.getElementById('peso').value);
    const actividad = document.getElementById('actividad').value;
    calcularBarf(tipo, edad, peso, actividad);
  });
}

function calcularBarf(tipo, edad, peso, actividad) {
  let porcentaje = 0;

  if (tipo === 'perro') {
    if (edad <= 4) porcentaje = 10;
    else if (edad <= 6) porcentaje = 8;
    else if (edad <= 8) porcentaje = 6;
    else if (edad <= 18) porcentaje = 3;
    else {
      switch (actividad) {
        case 'alta': porcentaje = 3; break;
        case 'normal': porcentaje = 2.5; break;
        case 'sedentario': porcentaje = 2; break;
        case 'deportista': porcentaje = 3.5; break;
        case 'mini': porcentaje = 3.5; break;
        case 'castrado': porcentaje = 2; break;
      }
    }
  } else if (tipo === 'gato') {
    if (edad <= 2) porcentaje = 10;
    else if (edad <= 4) porcentaje = 8;
    else if (edad <= 6) porcentaje = 6;
    else if (edad <= 8) porcentaje = 5.5;
    else {
      switch (actividad) {
        case 'alta': porcentaje = 5.5; break;
        case 'normal': porcentaje = 4; break;
        case 'sedentario': porcentaje = 3; break;
        case 'castrado': porcentaje = 3; break;
      }
    }
  }

  const cantidadBarf = peso * 1000 * (porcentaje / 100);
  document.getElementById('resultado-calculadora-barf').innerHTML = "Deberías darle a tu " + tipo + " unos " + cantidadBarf + " gramos de comida BARF al día";
}

function toggle_category_subcategories_filters(class_to_toggle) {
  var elements = document.getElementsByClassName(class_to_toggle);
  Array.from(elements).forEach((x) => {
    if (x.style.display === 'none') {
      x.style.display = 'block';
    } else {
      x.style.display = 'none';
    }
  });
}
